var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 29",
    style: {
      enableBackground: "new 0 0 27 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,16.3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S21.7,16.3,21,16.3z M21,13 c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S22.1,13,21,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,4.3C8.3,4.3,7.7,3.7,7.7,3S8.3,1.7,9,1.7s1.3,0.6,1.3,1.3S9.7,4.3,9,4.3z M9,1C7.9,1,7,1.9,7,3s0.9,2,2,2 s2-0.9,2-2S10.1,1,9,1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,6h-4.2v9.5L2.1,28h22.8l-9.3-12.4V6z M10.4,5h6.2v10.2L27,29H0l10.4-13.8V5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,26c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C9.7,25.2,10.5,26,11.4,26z  M11.8,18.5l-6.9,8.4h17.2l-6.9-8.4H11.8z M11.4,21.6c1.4,0,2.6,1.2,2.6,2.6s-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6 S10,21.6,11.4,21.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 5.6,
    className: "st1",
    width: 3.2,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    className: "st1",
    width: 0.8,
    height: 3.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.3,4.3 20.5,2 20,1.5 17.7,3.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.7,8.3 20,10.5 20.5,10 18.3,7.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.5,2 13.7,4.3 14.3,3.7 12,1.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsClicked);
export default __webpack_public_path__ + "static/media/analytics_clicked.df29f286c706e80adf705555f03d90f0.svg";
export { ForwardRef as ReactComponent };